module.exports = __webpack_public_path__ + "img/100.ed43ea9c.jpg";